import { FunctionComponent } from 'preact';
import cn from 'classnames';

export interface OverlayProps {
  isVisible?: boolean;
  className?: string;
}

export const Backdrop: FunctionComponent<OverlayProps> = ({
  children,
  isVisible,
  className,
}) => {
  return (
    <div
      className={cn(
        'vgp-backdrop',
        {
          'vgp-backdrop-hidden': !isVisible,
        },
        className
      )}
    >
      {children}
    </div>
  );
};
